<template>
  <div id="password-change-form-wrapper" class="vx-col m-5">
    <vx-card class="password-change-form mt-6">
      <div v-if="validUrl" class="vx-row no-gutter justify-center items-center">
        <div class="vx-col sm:w-full md:w-full lg:w-full">
          <div
            v-if="!isFirstStepSuccess"
            class="send-email flex flex-col gap-8"
          >
            <div class="vx-card__title h-8 flex justify-start items-center">
              <div class="aisea-text-14-400-dark-gray">
                パスワードを再設定してください。
              </div>
            </div>
            <form>
              <div class="vx-row mb-8">
                <div class="vx-col w-full mw">
                  <div class="w-full">
                    <vs-input
                      class="w-full"
                      label="ID"
                      v-model="loginKey"
                      name="loginKey"
                      :disabled="true"
                      data-vv-as="ID"
                    />
                  </div>
                </div>

              </div>
              <div class="vx-row">
                <div class="vx-col w-full mw">
                  <div class="w-full required" style="position: relative;"
                  >
                    <vs-input
                      ref="inputPassword"
                      :type="inputPasswordType"
                      class="w-full"
                      label="パスワード[半角英数記号８〜６４文字以内]"
                      v-model="password"
                      v-validate="'required|regex:^[!-~]+$|min:8|max:64'"
                      name="password"
                      data-vv-as="パスワード"
                      :icon="passwordVisibilityIcon"
                      @icon-click="togglePasswordVisibility"
                      icon-after="true"
                      autocomplete="new-password"
                    />
                    <span class="text-danger text-sm" style="margin-left: 0.6rem;" v-show="errors.has('password')">{{
                      errors.first("password")
                    }}</span>
                  </div>
                </div>

              </div>
            </form>

            <div>
              <div class="flex justify-end">
                <vs-button
                  class="
                    text-center
                    vs-con-loading__container
                    aisea-text-14-400-white
                  "
                  @click="onSubmit"
                  :disabled="!validateForm"
                  >登録</vs-button
                >
              </div>
            </div>
          </div>

          <div
            v-if="isFirstStepSuccess"
            class="flex flex-col gap-8"
          >
            <div class="vx-card__title h-8 flex justify-start items-center">
              <div class="aisea-text-14-600-dark-gray">
                パスワードが再設定されました。
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col w-full mw">
                <vs-row style="margin: 1rem 0;">
                  <vs-col class="aisea-text-16-400-dark-gray">再設定したパスワードを利用してログインしてください。</vs-col>
                </vs-row>
                <vs-row>
                  <vs-col vs-w="3" class="aisea-text-16-400-dark-gray">ユーザーID: </vs-col>
                  <vs-col vs-w="9" class="aisea-text-16-400-dark-gray">{{ loginKey }}</vs-col>
                </vs-row>
                <vs-row>
                  <vs-col vs-w="3" class="aisea-text-16-400-dark-gray">パスワード: </vs-col>
                  <vs-col vs-w="9" class="aisea-text-16-400-dark-gray">{{ password }}</vs-col>
                </vs-row>
                <div class="flex w-full justify-between items-start mt-4">
                  <div class="mt-1" style="position: absolute;">
                    <feather-icon
                      icon="AlertCircleIcon"
                      svgClasses="h-4 w-4"
                      :color="'silver'"
                    />
                  </div>
                  <div class="ml-6 aisea-text-16-400-dark-gray" >
                    パスワードをメモしてください。忘れた場合はパスワード再発行となります。
                  </div>
                </div>
              </div>
            </div>
            <div class="vx-row justify-end">
              <div class="vx-col">
                <vs-button to="/login/enterprise" >ログイン</vs-button>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div v-if="!validUrl" class="flex w-full justify-center items-center aisea-text-16-400-dark-gray" style="height: 40vh;">
        {{ inValidUrlMessage }}
      </div>
    </vx-card>
  </div>
</template>

<script>
import Vue from "vue";
import { AiseaApiFactory } from "@/api/aisea/apiFactory";
const enterpriseAdminAccountPasswordCertificatesApi = AiseaApiFactory.get("enterpriseAdminAccountPasswordCertificates");
import { DeviceInfoMixin, ColorMixin } from "@/mixins";

export default {
  name: "ChangePasswordForm",
  components: {},
  mixins: [DeviceInfoMixin, ColorMixin],
  data() {
    return {
      validUrl: false,
      inValidUrlMessage: '',

      enterpriseLoginKey: null , // APIコールで必要
      loginKey: null ,           // APIコールで必要
      certificationCode: null ,  // APIコールで必要
      cc: null ,                 // APIコールで必要
      password: "",              // APIコールで必要

      passwordVisibilityIcon: "visibility_off",
      inputPasswordType: "password",
      isFirstStepSuccess: false,
    };
  },
  computed: {
    validateForm() {
      return !this.errors.any() && this.password.length > 0;
    },
  },
  methods: {

    async checkPasswordUrl() {

      try {
        const res = await enterpriseAdminAccountPasswordCertificatesApi.get(this.enterpriseLoginKey, { cc: this.cc, });

        if ( res.status ) {
          // パスワード変更開始前検証 成功。
          this.loginKey  = res.data.email_address;
          this.certificationCode = res.data.certification_code;
          this.validUrl = true;
        } else {
          this.validUrl = false;
          this.inValidUrlMessage = 'URLが無効です。';
        }
      } catch(e) {
        Vue.$log.warn("error at enterpriseAdminAccountPasswordCertificatesApi.verification()", this.enterpriseLoginKey, this.cc, e);
        this.validUrl = false;
        this.inValidUrlMessage = 'URLが無効です。';
      }
        
      this.$emit('setIsValidUrl', this.validUrl);
    },

    togglePasswordVisibility() {
      if ( this.passwordVisibilityIcon === 'visibility_off' ) {
        this.passwordVisibilityIcon = 'visibility';
        this.inputPasswordType = "text";
      } else {
        this.passwordVisibilityIcon = 'visibility_off';
        this.inputPasswordType = "password";
      }      
    },

    async onSubmit() {

      const payload = {
        "certification_code": this.certificationCode,
        "login_key": this.loginKey,
        "password": this.password,
      };

      try {
        this.$vs.loading({ color: this.AISEA_COLOR.BLUE, });
        // APIコール
        console.debug("### password update api", this.enterpriseLoginKey, this.certificationCode, this.loginKey, this.password,);
        const res = await enterpriseAdminAccountPasswordCertificatesApi.update(this.enterpriseLoginKey, payload);
        this.$vs.loading.close();

        if ( res.status ) {
          this.$emit('nextTab');
          this.$nextTick(() => {
            this.isFirstStepSuccess = true;
            this.$vs.loading.close();
          });
        } else {
          Vue.$log.warn("error at enterpriseAdminAccountPasswordCertificatesApi.update()", this.enterpriseLoginKey, payload, res);
          this.$vs.notify({
            title: `パスワード変更`,
            text: `${this.enterpriseLoginKey}のパスワードを変更できませんでした`,
            color: "warning",
            icon: "done"
          });
        }

      } catch(e) {
        this.$vs.loading.close();
        Vue.$log.warn("error at enterpriseAdminAccountPasswordCertificatesApi.update()", this.enterpriseLoginKey, payload, e);
        this.$vs.notify({
          title: `パスワード変更`,
          text: `${this.enterpriseLoginKey}のパスワードを変更できませんでした`,
          color: "warning",
          icon: "done"
        });
      }
 
    },
  },
  created() {

      // 呼び出しURLを解析して、各種値をセット
      this.enterpriseLoginKey = this.$route.query['login_key'];
      this.cc                 = this.$route.query['cc'];

      this.checkPasswordUrl();

  },
  mounted() {
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
#password-change-form-wrapper {

  label {
    font-family: $aisea-font-family;
    font-size: 14px;
    font-weight: 600;
    color: $aisea-dark-gray;
  }

  .required label {
    &:after {
      content: " *";
      font-size: 0.8rem;
      color: rgba(var(--vs-danger),1);
    }
  }

  .password-change-form {
    min-width: 556px;
    max-width: 100%;
    filter: drop-shadow(0px 0px 30px rgba(112, 122, 141, 0.3));
    border-radius: 10px;

    .vx-card__body {
      padding: 2rem;
    }

    .vs-con-input-label.is-label-placeholder {
      margin-top: 30px;
    }
    .vs-input--icon.icon-after {
      border-left-color: #FFFFFF00;
      margin-top: 0.2rem;
    }

    .vs-inputx {
      font-family: $aisea-font-family;
      font-size: 16px !important;
      font-weight: 400;
    }
  }
}
</style>
